module.exports = __webpack_public_path__ + "img/9788993824643.e86fe6e0.jpg";